import { AgentThread } from "./agentThread";
import { BaseWorkflow } from "./BaseWorkflow";
export class Agent extends BaseWorkflow {
    constructor(agentId, socket) {
        super(socket);
        this.agentId = agentId;
    }
    channelName() { return `agent_com_${this.agentId}`; }
    thread() { return new AgentThread(this); }
}
